<template>
    <vs-prompt class="d-flex" buttons-hidden :title="'Editar concepto relacionado'"
        :active.sync="showDialogEditRelated">
        <div style="padding: 20px;">
            <vs-row>
                <p>Solo puedes modificar el valor del concepto. Si deseas modificar algo adicional, debes eliminarlo y volverlo a relacionar.</p>
            </vs-row>
            <vs-row>
                <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                    <label class="vs-input--label mb-0">Valor <span style="color: red;">*</span></label>
                    <vs-input class="inputx w-100" placeholder="Ingrese el valor" v-model="value" name="value" type="Number"
                        @input="value = value.slice(0, 7)" />
                </vs-col>
            </vs-row>
            <br/>
            <vs-row class="d-flex justify-content-end">
                <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
                    <div class="d-flex">
                        <vs-button color="primary" class="flex-shrink-0 ml-auto" style="margin-top: 0px;" @click="editRelated()">Editar</vs-button>
                    </div>
                </vs-col>
            </vs-row>
        </div>
    </vs-prompt>
</template>
<style>
.vs-dialog {
    max-width: 400px !important;
}
</style>
  
<script>
import { ROUTES } from "@/global/api_routes";

export default {
    name: "DialogEditRelated",
    props: {
        openDialogEditRelated: { type: Boolean },
        company: { type: String },
        relatedEdit: { type: Object },
    },
    data: () => ({
        showDialogEditRelated: false,
        value: null
    }),
    watch: {
        openDialogEditRelated() {
            this.showDialogEditRelated = this.openDialogEditRelated;
        },
        relatedEdit(){
            this.value = this.relatedEdit.value;
        }
    },
    methods: {
        closeEditRelated() {
            this.$emit('closeEditRelated');
        },
        editRelated(){
            this.$validator.validateAll().then((result) => {
                if (!result) {
                    return;
                }
                this.$vs.loading();
                this.$http
                    .put(ROUTES.DASHBOARD.LIQUIDATIONS.UPDATE_LIQUIDATION_CONCEPT, this.getRelated())
                    .then(({ data }) => {
                        if (data.code > 0) {
                            this.$toastOk("El valor se ha actualizado correctamente");
                            this.$emit('receiveNewValue');
                            this.closeEditRelated();
                            return;
                        }
                        else { this.$toastError(data.message); }
                    })
                    .finally(() => {
                        this.$vs.loading.close();
                    });
            });
        },
        getRelated(){
            return {
                code: this.relatedEdit.code,
                concept: this.relatedEdit.concept,
                runtimeType: this.relatedEdit.runtimeType.code,
                value: this.value,
                function: this.relatedEdit.functionType,
                tariff: this.relatedEdit.rate
            }
        }
    }
};
</script>